<mat-form-field appearance="outline" class="w-100">
  <mat-label>Finca</mat-label>
  <mat-select
    [disabled]="!cell.isEditable()"
    [ngModel]="cell.getValue()"
    (ngModelChange)="cell.setValue($event)"
    [ngModelOptions]="{ standalone: true }"
  >
    <mat-option *ngFor="let finca of fincas" [value]="finca.idFinca">
      {{ finca.idFinca }} - {{ finca.name }} - {{ finca.city }}
    </mat-option>
  </mat-select>
</mat-form-field>
